export const constants = {
  url: {
    tvl: "https://universe.staderlabs.com/common/tvl",
  },
};

export const SCREEN_SIZES = {
  MOBILE: "(max-width: 599px)",
  TABLET: "(min-width: 600px)",
  DESKTOP: "(min-width: 1200px)",
};

export interface IIndexable {
  [key: string]: any;
}
